module.exports = __webpack_public_path__ + "static/media/13_XO.312c94a6.png";